import React from "react";
import { useSelector } from "react-redux";
import { Link, NavLink } from "react-router-dom";
import Collapsible from "../collapsible/Collapsible";

const Sidebar = () => {

    const user = useSelector(state => state.auth.authUser);

    return (
        <div className="sidebar">
            <Collapsible title="Students" open={true}>
                <NavLink to="/portal/students/all-students" className={({ isActive }) => isActive ? "active-link" : ""}>All students</NavLink>
                <NavLink to="/portal/students/update-student-progress" className={({ isActive }) => isActive ? "active-link" : ""}>Roadmap</NavLink>
                <NavLink to="/portal/students/progress-tracking" className={({ isActive }) => isActive ? "active-link" : ""}>Progress tracking</NavLink>
                <NavLink to="/portal/students/baseline" className={({ isActive }) => isActive ? "active-link" : ""}>Baseline</NavLink>
                <NavLink to="/portal/students/notes" className={({ isActive }) => isActive ? "active-link" : ""}>Notes</NavLink>
                <NavLink to="/portal/students/edit-details" className={({ isActive }) => isActive ? "active-link" : ""}>Edit details</NavLink>
            </Collapsible>

            {(user.user_role !== 'supply_ta' && user.user_role !== 'tutor') && (
                <Collapsible title="Reporting" open={true}>
                    <Link to="/portal/group-reports">Group reports</Link>
                    <Link to="/portal/roadmaps">Roadmaps</Link>
                </Collapsible>
            )}
            
            {user.user_role === 'slt_member' && (
                <Collapsible title="Admin" open={true}>
                    <Link to="/portal/manage-tutors?view=list">Manage tutor group leads</Link>
                    <Link to="/portal/manage-tutor-groups?view=list">Manage tutor groups</Link>
                </Collapsible>
            )}

            {user.user_role === 'super_admin' && (
                <Collapsible title="Admin" open={true}>
                    <Link to="/portal/manage-tutors?view=list">Manage tutor group leads</Link>
                    <Link to="/portal/manage-tutor-groups?view=list">Manage tutor groups</Link>
                    <Link to="/portal/manage-schools?view=list">Manage schools</Link>
                    <Link to="/portal/manage-users?view=list">Manage users</Link>
                </Collapsible>
            )}
        </div>
    );
}

export default Sidebar;